import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@americanexpress/aqx-components';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { SectionTitle } from 'page_modules/business-pdp/components/SectionTitle';

import { getFeeData } from 'page_modules/business-pdp/redux';
import { getPageLabels } from 'src/universal/redux/page';
import withPropTestingData from 'src/universal/components/WithPropTestingData';
import { DATA_TYPES } from 'src/universal/redux/propTesting';

import styles from './__styles__/index.scss?modules';

const feeBox = React.memo(({ feeData, pageLabels }) => {
  const allowRender = !!feeData;
  return (
    allowRender && (
      <div className={styles.feeBoxWrap}>
        <React.Fragment>
          <SectionTitle text={pageLabels.feesSectionTitle} />
          <Box
            $border={true}
            className={styles.content}
            theme={{
              paddingTop: 25,
              paddingBottom: 25,
              paddingLeft: 20,
              paddingRight: 20
            }}
          >
            <Sanitizer safelySetInnerHTML={feeData} />
          </Box>
        </React.Fragment>
      </div>
    )
  );
});

const PropsTestedFeeBox = withPropTestingData(feeBox, 'FeeBox', DATA_TYPES.cardData);

const mapStateToProps = state => ({
  feeData: getFeeData(state),
  pageLabels: getPageLabels(state)
});

export const FeeBox = connect(mapStateToProps)(PropsTestedFeeBox);
